import { Produto } from "src/assets/IPB/models";
import { ARADO_SUBSOLADOR } from "src/assets/IPB/Produtos/Arado_Subsolador/ARADO_SUBSOLADOR";
import { ARADO_SUBSOLADOR_DISCO_CORTE } from "src/assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/ARADO_SUBSOLADOR_DISCO_CORTE";
import { ARROZERA } from "src/assets/IPB/Produtos/Arrozera/ARROZERA";
import { CARRETA_AGRICOLA_METALICA_HIDRAULICA } from "src/assets/IPB/Produtos/Carreta_Agricola_Matelica_Hidraulica/CARRETA_AGRICOLA_METALICA_HIDRAULICA";
import { CONCHA_TRASEIRA_CT300 } from "src/assets/IPB/Produtos/Concha_Traseira_CT-300/CONCHA_TRASEIRA_CT300";
import { GRAMPO_LIMPADOR_SOLO } from "src/assets/IPB/Produtos/Grampo_Limpador_Solo/GRAMPO_LIMPADOR_SOLO";
import { GUINCHO_HIDRAULICO_GH1000 } from "src/assets/IPB/Produtos/Guincho GH-1000 Hidráulico/GUINCHO_HIDRAULICO_GH1000";
import { GUINCHO_HIDRAULICO_BAG } from "src/assets/IPB/Produtos/Guincho_Hidraulico_BAG/GUINCHO_HIDRAULICO_BAG";
import { GUINCHO_TRASEIRO_3PONTO } from "src/assets/IPB/Produtos/Guincho_Traseiro_3Ponto/GUINCHO_TRASEIRO_3PONTO";
import { PERFURADOR_SOLO } from "src/assets/IPB/Produtos/Perfurador_Solo/PERFURADOR_SOLO";
import { PLATAFORMA_BASCULANTE } from "src/assets/IPB/Produtos/Plataforma_Basculante_Corte/PLATAFORMA_BASCULANTE";
import { ROCADEIRA } from "src/assets/IPB/Produtos/Rocadeira/ROCADEIRA";
import { SEMEADOR_ADUBADOR } from "src/assets/IPB/Produtos/Semeador_Adubador/SEMEADOR_ADUBADOR";
import { SEMEADOR_ADUBADOR_DUPLO_2 } from "src/assets/IPB/Produtos/Semeador_Adubador_Duplo_2/SEMEADOR_ADUBADOR_DUPLO_2";
import { SEMEADOR_ADUBADOR_GIR800 } from "src/assets/IPB/Produtos/Semeador_Adubador_GIR-800/SEMEADOR_ADUBADOR_GIR800";
import { TANQUE_BEBEDOURO } from "src/assets/IPB/Produtos/Tanque_Bebedouro/TANQUE_BEBEDOURO";

let PRODUCTS: Array<Produto> = [
    ARADO_SUBSOLADOR
    , ARADO_SUBSOLADOR_DISCO_CORTE
    , ARROZERA
    , CARRETA_AGRICOLA_METALICA_HIDRAULICA
    , CONCHA_TRASEIRA_CT300
    , GRAMPO_LIMPADOR_SOLO
    , GUINCHO_HIDRAULICO_GH1000
    // , GUINCHO_GH1000
    , GUINCHO_HIDRAULICO_BAG
    , GUINCHO_TRASEIRO_3PONTO
    , PLATAFORMA_BASCULANTE
    , ROCADEIRA
    , SEMEADOR_ADUBADOR
    , SEMEADOR_ADUBADOR_DUPLO_2
    , SEMEADOR_ADUBADOR_GIR800
    , TANQUE_BEBEDOURO
    , PERFURADOR_SOLO
    // , SEMEADOR_ADUBADOR_DUPLO
];


PRODUCTS = PRODUCTS.map(item => {

    if (item.Imagens) {
        item.Imagens = item.Imagens.map(img => {
            img.ThumbUrlM = `assets/IPB/Thumbs/thumbM_${img.Url.substring(img.Url.lastIndexOf('/')+1)}`;
            img.ThumbUrlP = `assets/IPB/Thumbs/thumbP_${img.Url.substring(img.Url.lastIndexOf('/')+1)}`;
            return img;
        })
    }

    console.log(item);

    return item;
});

export const DATA_PRODUCTS = PRODUCTS;
